$(document).ready(function(){

  $('input[type=text]').blur();

  $('.sub-menu-button').click(function(){
    $('.header-sub-menu').toggleClass('top-out')
  })

  $('.login-button, .login-shade, .button-close-login-panel').click(function(){
    if( $('.login-panel').hasClass('left-out') && $('.login-block').hasClass('hidden') ){
      $('.login-block').removeClass('hidden')
      $('.reset-block').addClass('hidden')
    }
    $('.login-panel').toggleClass('left-out')
    $('.login-shade').toggleClass('is-active')
  })

  $('.reset-button').click(function(){
    $('.login-block').addClass('hidden')
    $('.reset-block').removeClass('hidden')
  })

  $('.reset-cancel-button').click(function(){
    $('.login-block').removeClass('hidden')
    $('.reset-block').addClass('hidden')
  })

  $('.expandable-button').click(function() {
    $(this).closest('.expandable').toggleClass('expanded')
  })

  $('.main-menu-button').click(function(){
    if($('.sub-menu.is-active').length > 0) {
      $('.sub-menu').removeClass('is-active')
    } else {
      $('.main-navigation-menu-list').toggleClass('is-active')
    }
  })

  $('.sub-menu-button').click(function(){
    $(this).siblings('.sub-menu').addClass('is-active')
  })
  

})